import { InputNumber } from 'antd';
import { useEffect, useState } from 'react'

IntegerInput = ({
  initialValue,
  save,
  inputValidator=({ target: { value } }) ->
    if !isNaN(value)
      value
  props...
}) ->

  [loading, setLoading] = useState(false)
  [value, setValue] = useState(initialValue)

  useEffect(->
    setValue(initialValue)
  , [initialValue])

  <InputNumber
    value={value}
    disabled={loading}
    formatter={(value) -> "#{value}".replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
    parser={(value) -> value.replace(/[.]/g, '')}
    {props...}
  />

export default IntegerInput
